import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee8e4bf2")

_pushScopeId("data-v-ee8e4bf2")
const _hoisted_1 = { class: "main-search-container dark-overlay" }
const _hoisted_2 = { class: "main-search-inner" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", null, "Find Nearby Attractions", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", null, "Expolore top-rated attractions, activities and more", -1)
const _hoisted_8 = { class: "main-search-input" }
const _hoisted_9 = { class: "main-search-input-item" }
const _hoisted_10 = { class: "guests-buttons" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "guestsQtyTitleSearchBar" }, "How many guests?", -1)
const _hoisted_12 = { class: "main-search-input-item" }
const _hoisted_13 = { class: "main-search-input-item" }
const _hoisted_14 = { class: "main-search-input-item" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option data-v-ee8e4bf2>Luxembourg</option><option data-v-ee8e4bf2>Diekirch</option><option data-v-ee8e4bf2>Differdange</option><option data-v-ee8e4bf2>Dudelange</option><option data-v-ee8e4bf2>Echternach</option><option data-v-ee8e4bf2>Esch-sur-Alzette</option><option data-v-ee8e4bf2>Ettelbruck</option><option data-v-ee8e4bf2>Remich</option><option data-v-ee8e4bf2>Rumelange</option><option data-v-ee8e4bf2>Vianden</option><option data-v-ee8e4bf2>Wiltz</option>", 11)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode("div", {
                    class: "guestsQtyDec",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decGuests && _ctx.decGuests(...args)))
                  }),
                  _withDirectives(_createVNode("input", {
                    type: "number",
                    name: "qtyInput",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.guests = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.guests]
                  ]),
                  _createVNode("div", {
                    class: "guestsQtyInc",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.incGuests && _ctx.incGuests(...args)))
                  })
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.searchDateStart,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchDateStart = $event)),
                  "min-date": _ctx.minDate,
                  mode: "dateTime",
                  is24hr: "",
                  "minute-increment": 15
                }, {
                  default: _withId(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({ value: inputValue }, _toHandlers(inputEvents)), null, 16, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.searchDateEnd,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchDateEnd = $event)),
                  "min-date": _ctx.searchDateStart,
                  mode: "dateTime",
                  is24hr: "",
                  "minute-increment": 15
                }, {
                  default: _withId(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({ value: inputValue }, _toHandlers(inputEvents)), null, 16, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ]),
              _createVNode("div", _hoisted_14, [
                _withDirectives(_createVNode("select", {
                  "data-placeholder": "Location",
                  class: "chosen-select",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchCity = $event))
                }, [
                  _hoisted_15
                ], 512), [
                  [_vModelSelect, _ctx.searchCity]
                ])
              ]),
              _createVNode("button", {
                class: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.searchPlaces && _ctx.searchPlaces(...args)))
              }, "Search")
            ])
          ])
        ])
      ])
    ])
  ]))
})